module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/client/my-forecast/my-forecast.component.scss
// module id = ./src/app/pages/client/my-forecast/my-forecast.component.scss
// module chunks = main